module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Konstruktor"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.id),
      expression: "scenario.id"
    }],
    staticClass: "scenarioId",
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.scenario.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario, "id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.id),
      expression: "scenario.id"
    }],
    staticClass: "clientId",
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.scenario.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario, "id", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "jtk-demo-main",
    attrs: {
      "id": "jtk-demo-flowchart"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "jtk-demo-canvas canvas-wide flowchart-demo jtk-surface jtk-surface-nopan",
    attrs: {
      "id": "canvas"
    }
  }, [_c('jsplumb-toolkit', {
    ref: "toolkitComponent",
    attrs: {
      "view": _vm.view,
      "scenarioId": _vm.scenario.id,
      "client": _vm.name,
      "available-sms-gateways": _vm.availableSmsGateways
    },
    on: {
      "update:scenarioId": function($event) {
        return _vm.$set(_vm.scenario, "id", $event)
      },
      "update:scenario-id": function($event) {
        return _vm.$set(_vm.scenario, "id", $event)
      },
      "update:availableSmsGateways": function($event) {
        _vm.availableSmsGateways = $event
      },
      "update:available-sms-gateways": function($event) {
        _vm.availableSmsGateways = $event
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "zoomShell"
  }, [_c('zoom', {
    attrs: {
      "element-id": "canvas"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "scenarioBarShell"
  }, [_c('tool-buttons', {
    attrs: {
      "name": _vm.name,
      "scenario": _vm.scenario,
      "campaign-id": _vm.campaignid
    },
    on: {
      "update:scenario": function($event) {
        _vm.scenario = $event
      },
      "set": _vm.setScenario,
      "setDefault": _vm.setScenario,
      "initScenario": _vm.initScenarioFromCanvas
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "scenarioCommonParametersViewShell"
  }, [_c('ScenarioCommonParams', {
    attrs: {
      "hide-arrows": _vm.scenario.parameters.visual.hideArrows,
      "scenario-name": _vm.scenario.name,
      "locale": _vm.scenario.parameters.common.locale,
      "recognition-driver": _vm.scenario.parameters.common.recognitionDriver
    },
    on: {
      "hideArrowsChange": _vm.hideArrowsChange,
      "scenarioNameChange": _vm.scenarioNameChange,
      "localeChange": _vm.localeChange,
      "recognitionDriverChange": _vm.recognitionDriverChange
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b061a42a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/konstruktor/ScenarioKonstruktor.vue
// module id = 643
// module chunks = 42